// PRD 21 §10.5 — render a deploy history entry's change summary as
// 'PRO 항목 N건, 문항 N건, 관리지침 N건, 모듈 구성 변경'. Categories with no
// changes are skipped. If everything is zero/false, the prototype falls back
// to '변경 없음' (mcBtnDeploy click handler L1074).

import type { TFunction } from 'i18next';

import type { DeploySummary } from '../types/pro-deployment.types';

export function formatDeploySummary(summary: DeploySummary, t: TFunction): string {
  const parts: string[] = [];
  if (summary.itemsCount > 0) {
    parts.push(t('history.summaryParts.items', { count: summary.itemsCount }));
  }
  if (summary.surveysCount > 0) {
    parts.push(t('history.summaryParts.surveys', { count: summary.surveysCount }));
  }
  if (summary.guidelinesCount > 0) {
    parts.push(t('history.summaryParts.guidelines', { count: summary.guidelinesCount }));
  }
  if (summary.moduleConfigChanged) {
    parts.push(t('history.summaryParts.moduleConfig'));
  }
  if (parts.length === 0) {
    parts.push(t('history.summaryParts.noChange'));
  }
  return parts.join(', ');
}
